import { mappedTraits } from './modes';

export function preview(state) {
  return mappedTraits[state.mode.type].preview(state);
}
